import type { Raffle } from 'src/types/raffle';

export function getRaffleDisplayName(raffle: Raffle): string {
  return raffle.name ?? raffle.ordinalName ?? raffle.runesTokenName ?? 'Unnamed Raffle';
}

export function getRaffleImage(raffle: Raffle): string {
  if (raffle.ordinalImageUrl) return raffle.ordinalImageUrl;
  if (raffle.runesImageUrl) return raffle.runesImageUrl;
  // Deterministic placeholder based on raffle id
  const hash = raffle.id.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  const index = (hash % 14) + 1;
  return `/assets/images/raffle/raffle-image-${index}.png`;
}

export function getRaffleCreator(raffle: Raffle): string {
  if (!raffle.creator?.id) return 'Unknown';
  const id = raffle.creator.id;
  return `${id.slice(0, 6)}...${id.slice(-4)}`;
}

export function formatTicketsSold(raffle: Raffle): string {
  return `${raffle.ticketsSold.toLocaleString()} / ${raffle.supply.toLocaleString()}`;
}

export function satsToBtc(sats: number | string): number {
  return Number(sats) / 1e8;
}

export function normalizeRaffle(raw: any): Raffle {
  return {
    ...raw,
    ticketPriceSats: Number(raw.ticketPriceSats),
    totalTicketValue: Number(raw.totalTicketValue),
    featuredFeeSats: raw.featuredFeeSats != null ? Number(raw.featuredFeeSats) : null,
    runesAmount: raw.runesAmount != null ? Number(raw.runesAmount) : null,
    supply: Number(raw.supply),
    ticketsSold: Number(raw.ticketsSold),
    numberOfWinners: Number(raw.numberOfWinners),
  };
}
